import { TermsOfUse } from './terms/TermsOfUse';

const TermsAndConditionsRegistration = () => {
  return <TermsOfUse></TermsOfUse>;
};

export default TermsAndConditionsRegistration;
